// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__footer__1NlzQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/footer.scss
// module id = 213
// module chunks = 0